// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"RDBzZqLJ"};